/**
 * Token de inyección para MultimediaRepository
 */

import { InjectionToken } from '@angular/core';
import { MultimediaRepository } from './multimedia.repository';

export const MULTIMEDIA_REPOSITORY_TOKEN = new InjectionToken<MultimediaRepository>('MultimediaRepository');

